import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ContentBody from '../../../layout/content/ContentBody';
import AggregatedModuleAlerts from '../../../shared-components/alerts/AggregatedModuleAlerts';
import LoadingState from '../../../shared-components/LoadingState';
import { ExerciseCategoriesContext } from '../_contexts/ExerciseCategoriesContext';
import ModuleContext from '../_contexts/ModuleContext';
import ExerciseCategoryCard from './components/ExerciseCategoryCard';

function VirtualExerciseModuleOverview() {
  const { t } = useTranslation();
  const { allModules } = useContext(ModuleContext);

  const { exerciseCategories, loading } = useContext(ExerciseCategoriesContext);

  return (
    <ContentBody alerts={<AggregatedModuleAlerts selectedModules={allModules} />}>
      <div className="vem">
        <section className="list-cards">
          {loading ? (
            <LoadingState variant="list" aria-label={t('PAGES.VEM.CARDS.LOADING.A11Y_LABEL')} size={6} height={82} />
          ) : (
            exerciseCategories.map(exerciseCategory => (
              <ExerciseCategoryCard key={exerciseCategory.id} exerciseCategory={exerciseCategory} />
            ))
          )}
        </section>
      </div>
    </ContentBody>
  );
}

export default VirtualExerciseModuleOverview;
